import { render, staticRenderFns } from "./PostAlignment.vue?vue&type=template&id=69fb96b0"
import script from "./PostAlignment.vue?vue&type=script&lang=js"
export * from "./PostAlignment.vue?vue&type=script&lang=js"
import style0 from "./PostAlignment.vue?vue&type=style&index=0&id=69fb96b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports